export default "__VITE_ASSET__C6FoQO5y__"